import GlobalQuickJump from "../../../../../global/GlobalQuickJump";

export default function MembershipQuickJumpSection(props) {
  return <GlobalQuickJump {...props} />;
}
